<script lang="ts" setup>

</script>

<template>
    <div className="w-full h-full grid grid-cols-2 place-items-stretch">
        <div id="Picture" class="flex flex-col items-center justify-center gap-y-4 px-4 py-4 rounded-[5px] select-none">
            <img src="~@/assets/map-mini.png" alt="" />
        </div>
        <div id="Description" class="flex flex-col items-center justify-center gap-y-4 px-4 py-4 rounded-[5px]">
            <h1 class="text-center text-[3em] font-bold">Interaktywna Mapa Pustkowi</h1>
            <p class="text-justify w-full font-bold">Z powodu mutantów, gangów, zbuntowanych maszyn i anomalii, sporządzenie mapy Kraju Winków nie było zadaniem łatwym. Na szczęście znalazła się grupa śmiałków, która przemierzyła Ödland wzdłuż i wszerz aby sporządzić interaktywną mapę Pustkowi Winków! Nie było to zadanie łatwe i zajęło im to wiele dni, dlatego jak spotkacie któregoś osobiście, postawcie mu kufelek “Uranowego” w najbliższej spelunie.</p>
            <p class="text-justify w-full font-bold">Dzięki dobrodziejstwu WinkoNET’u 5.0 również i Ty drogi przybyszu, możesz rzucić okiem na nasz kraj i dojść do wniosku, że wycieczka na Zagranicze nie jest niczym dobrym, bo tam jest <em class="italic">prohybycja</em> i Hasseland.</p>
            <router-link class="text-[1.5em] font-bold hover:text-white transition-colors duration-500" to="/map">Otwórz Mapę (BETA)</router-link>
        </div>
    </div>
</template>

<style lang="scss">
#Picture {
    background-color: rgba(#12FF15, .4);
    //filter: invert(58%) sepia(20%) saturate(1803%) hue-rotate(71deg) brightness(117%) contrast(126%);
}

#Description {
    background-color: rgba(#111, .4);
    color: #12FF15;
}
</style>